import { useMemo } from 'react'

import { useCurrencySign } from 'app/common/components-next/currency'

import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'

import {
  columnKeysLeft,
  columnKeysLeftHeaders,
  columnKeysRight,
  columnKeysRightHeaders,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  createData,
  createDataProps,
  createDataTotal,
  createHeaderCells,
  createHeaderCellsProps,
  createTotalDataProps,
  renderTableCell,
  tdPropsByRowAndColumnKey,
} from './table-options'

import { ByPaymentMethodSchool, ByPaymentMethodTotals } from './types'
import styles from './TableByPaymentMethod.module.scss'

const firstColumnWidht = 300 as const
const lastColumnWidth = 270 as const

type Props = {
  dates: Array<string>
  schools: Array<ByPaymentMethodSchool>
  totals: ByPaymentMethodTotals
  dateFormat: string
}

export const TableByPaymentMethodSplitted = ({ dates, schools, totals, dateFormat }: Props) => {
  const currency = useCurrencySign()

  const tableData = useMemo(() => {
    const mainColumnKeys = createColumnKeysMain(dates)
    return {
      columnKeysLeft: columnKeysLeft,
      columnKeysLeftHeaders: columnKeysLeftHeaders,
      columnKeysMain: mainColumnKeys,
      columnKeysMainHeaders: createColumnKeysMainHeaders(dates),
      columnKeysRight: columnKeysRight,
      columnKeysRightHeaders: columnKeysRightHeaders,
      header: createHeaderCells(currency, dateFormat, 'DD.MM.YYYY'),
      headerProps: createHeaderCellsProps({ firstColumnWidht, lastColumnWidth }),
      data: createData({
        schools,
        columnKeysMain: mainColumnKeys,
      }),
      dataProps: createDataProps({ firstColumnWidht, lastColumnWidth }),
      total: createDataTotal({
        totals,
        columnKeysMain: mainColumnKeys,
      }),
      totalProps: createTotalDataProps({ firstColumnWidht, lastColumnWidth }),
    }
  }, [dates, schools, totals, dateFormat, currency])

  return (
    <div>
      <CompositeTableTemplate
        data={tableData}
        renderCell={renderTableCell}
        renderFooterCell={renderCellGrayZeros}
        tdPropsByRowAndColumnKey={tdPropsByRowAndColumnKey}
        className={styles.stickyFix}
        borderTop
      />
    </div>
  )
}
